import axios from "axios";
import { attachAuthRefresh } from "../utils/tokenRefresh";

const KUNDLI_BASE = process.env.REACT_APP_API_BASE_URL || "";
const SESSIONS_BASE = KUNDLI_BASE.replace(/\/api\/kundli\/?$/, "/api/sessions");

export const sessionsApi = axios.create({
  baseURL: SESSIONS_BASE,
  headers: { "Content-Type": "application/json" },
});

sessionsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("kc_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

attachAuthRefresh(sessionsApi);

const unwrap = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) => {
      const body = err.response?.data;
      const message = body?.message || body?.detail || "Something went wrong.";
      throw { message, errors: body?.errors, status: err.response?.status };
    });

// GET /api/sessions/dashboard/ -> User Dashboard (Client)
export const getClientDashboard = () => unwrap(sessionsApi.get("/dashboard/"));

// GET /api/sessions/astrologer-dashboard/ -> Astrologer/Pandit Dashboard
export const getAstrologerDashboard = () => unwrap(sessionsApi.get("/astrologer-dashboard/"));
